import { Injectable } from '@angular/core';
import { Lab } from '../contracts/lab/lab.model';
import { StudyTestRecommendation } from '../contracts/recommendation/recommendation-model';
import { RecommendedResult } from '../contracts/recommendation/recommended-result-model';
import { store } from './store/mc-store';
import { QcPlanDetailOption } from '../contracts/qc-plan/qc-plan-detail.model';
import { OnBoardingAnalyte } from '../contracts/onboarding/onboarding-analyte.model';

@Injectable()
export class StateService {

  constructor() { }

  // Lab
  getCurrentLab(): Lab {
    return this.getCurrentState().labState.currentLab;
  }

  // Recommendations
  getRecommendations(): StudyTestRecommendation[] {
    return this.getCurrentState().recommendationState.recommendations;
  }

  getSelectedStudyTestRecommendation(): StudyTestRecommendation {
      return this.getCurrentState().recommendationState.selectedStudyTestRecommendation;
  }

  getSelectedRecommendation(): RecommendedResult {
    return this.getCurrentState().recommendationState.selectedRecommendation;
  }

  getAnalyteByStudyTestId(studyTestId: number): OnBoardingAnalyte {
    return this.getCurrentState().onboardingState.analytes.find(a => a.studyTestId === studyTestId);
  }

  getCurrentQcPlanDetailOption(): QcPlanDetailOption {
    return this.getCurrentState().qcPlanDetailOptionState.qcPlanDetailOption;
  }

  getCurrentState() {
    return store.getState();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/state.service.ts